module.exports = {
  CartItems: require('../cart_widget/templates/cart_items.html.mustache'),
  CartEmpty: require('../cart_widget/templates/cart_empty.html.mustache'),
  CartSpinner: require('../cart_widget/templates/cart_spinner.html.mustache')
};

